module.exports = __webpack_public_path__ + "img/icon-rectangleorangexs.2ac427e6.svg";